var map = {
	"./banprime/logo-mini-color.png": "c802",
	"./ezzebank/logo-mini-color.png": "bd95",
	"./groovebank/logo-mini-color.png": "0561",
	"./hubchain/logo-mini-color.png": "1629"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b2e3";